<span [class]="spinnerClass()" role="status" [attr.aria-label]="label()"></span>
